/**
 * The slot registrations of `web/sessions` (2.D deliverable 9): Tonight at the top of the sidebar
 * (`shell.top.tonight`) and on Home (`home.sections.tonight`), each empty while the `sessions`
 * flag is off. `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/sessions']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { TonightHomeCard, TonightNavEntry } from './tonight/entries.js';

export const owner: WorkPackageId = '2.D';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'shell.top', order: 10, owner: '2.D', component: TonightNavEntry },
  { slot: 'home.sections', order: 10, owner: '2.D', component: TonightHomeCard },
];
